
import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    clearAuth(state) {
      state.token = null
      state.userInfo = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('setToken', token)
    },
    setUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    },
    logout({ commit }) {
      commit('clearAuth')
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo
  }
})
